import { ShoppingBag } from "@mui/icons-material";
import { Button, FormLabel, TextField } from "@mui/material";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../context";
import { motion } from "framer-motion";
import Logo from '../../Images/logo.png'
import Loading from "../Loading";

const CheckOut = () => {
  const [Value, setValues] = useState([]);
  const { UserId,UserName } = useContext(AppContext);
  const[Name,setName] = useState(UserName)
  const[loading,setLoading] = useState(true)
  const[text,setText] = useState("Fetching your details...")
  const { data } = useParams();
  const [id,Quantity, Price] = data.split("&");
  const price = parseInt(Quantity) * parseInt(Price);
  const token = localStorage.getItem("authtoken");
  axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  const navigate = useNavigate();

  useEffect(() => {
    getDetails(UserId);
  }, [UserId]);
  const getDetails = async (Id) => {
    try {
      const response = await axios.get(`https://winterstore-backend.onrender.com/Profile/${Id}`);
      if (response.status === 200) {
        setValues(response.data);
        setLoading(false)
      }
    } catch (error) {
      toast.error("Server not available at this moment");
    }
  };
  const handleChange = (e) => {
    setValues({
      ...Value,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (UserId, id,Value) => {
    setText("Placing Order...")
    setLoading(true)
    // var rzp1 = new window.Razorpay(options);
      const Data = {
        ...Value,
        Price: price,
      };
  
      try {
        const response = await axios.post(
          `https://winterstore-backend.onrender.com/order/checkout`,
          Data
        );
        if (response.status === 200) {
          setLoading(false)
          const {key,orderId} = response.data
      var options = {
        "key": key, 
        "amount": Price, 
        "currency": "INR",
        "name": "WinterStore",
        "description": "",
        "image": "",
        "order_id": orderId, 
        "handler": async function (response){
          setText("Placing Order....")
          setLoading(true)
          const data = await axios.post(`https://winterstore-backend.onrender.com/order/PaymentVerification/${UserId}`,{
           response,Value:Value,UserId:UserId,UserName:Name,ProductId: id,Price:price,Email:Value.Email
          })
          if(data.status === 201){
            setLoading(false)
            toast.success('item successfully Ordered');
            navigate(`/OrderSuccess/${data.data.OrderId}`);
          }else{
            setLoading(false)
            toast.error('Something Went Wrong');

          }
      },
        "prefill": {
            "name": Name,
            "email": Value.Email,
            "contact": Value.Phone
        },
        "notes": {
            "address": Value.Address+" " + Value.City +" " +Value.State+" " + Value.Zip
        },
        "theme": {
            "color": "#101E2B"
        }
      };
      var rzpay = new window.Razorpay(options)
      rzpay.open()
          
        }
      } catch (error) {
        toast.error("Something went wrong.");
      }
    };
    return (
      <>
      {loading ? (
        <div style={{marginTop:"320px"}}>
    <Loading text={text}/>
        </div>
      ) : (
        <motion.div
      initial={{ x: "-100vw" }}
      animate={{ x: 0 }}
      transition={{ duration: 2, type: "spring" }}
      className="container p-5 mt-2 mb-2"
      style={{
        margin: "auto",
        backgroundColor: "#101E2B",
        boxShadow: "0 15px 25px rgba(0,0,0,.6)",
        borderRadius: "10px",
      }}
    >
      <h3 className="py-2 text-light text-center">
        <i className="bi bi-bag-heart-fill me-2"></i>Checkout Page
      </h3>

      <FormLabel className="text-light m-2">Customer Name</FormLabel>
      <TextField
        type="text"
        value={Name}
        onChange={(e)=>setName(e.target.value)}
        className="form-control"
        name="Name"
      />

      <div className="row">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">Address</FormLabel>
          <TextField
            type="text"
            value={Value.Address}
            onChange={handleChange}
            className="form-control"
            name="Address"
          />
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">City</FormLabel>
          <TextField
            type="text"
            value={Value.City}
            onChange={handleChange}
            className="form-control"
            name="City"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">State</FormLabel>
          <TextField
            type="text"
            value={Value.State}
            onChange={handleChange}
            className="form-control"
            name="State"
          />
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">ZipCode</FormLabel>
          <TextField
            type="text"
            value={Value.Zip}
            onChange={handleChange}
            className="form-control"
            name="Zip"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">Contact</FormLabel>
          <TextField
            type="text"
            value={Value.Phone}
            onChange={handleChange}
            className="form-control"
            name="Phone"
          />
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <FormLabel className="text-light m-2">Total Price</FormLabel>
          <TextField
            type="text"
           
            defaultValue={price}
          InputProps={{
            readOnly: true,
          }}
            className="form-control"
            name="totalPrice"
          />
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12 col-lg-6 ">
          <Button
          size="medium"
        className="text-center py-2 mt-2"
        startIcon={<ShoppingBag  />}
        style={{
    
          margin: "auto",
          borderRadius: "5px",
          backgroundColor: "#149686",
        }}
        variant="contained"
        onClick={() => handleSubmit(UserId, id,Value)}
      >
        Order Now
      </Button>
          </div>
        </div>
      </div>
  
    </motion.div>
      )}
      </>
    
  )
};

export default CheckOut;
